import React, {Component} from 'react';
import {Dropdown} from 'semantic-ui-react';
import _ from 'lodash';

export class DropDown extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = (e, {value}) => this.props.onTargetChange(value);

  render() {
    let options = this.props.setAsides.map((result) => ({
      key: result.id,
      text: result.targetName,
      value: result.id,
    }));

    return (
      <Dropdown
        options={options}
        onChange={this.handleChange}
        text="Change funding target"
        id="content"
        target="_self"
      />
    );
  }
}
